/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Pump_Confirm_Off_DescInputs */

const vi_irrigation_pump_confirm_off_desc = /** @type {(inputs: Irrigation_Pump_Confirm_Off_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lệnh này tắt máy bơm thật của bộ tưới.`)
};

/**

* @param {Irrigation_Pump_Confirm_Off_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_pump_confirm_off_desc = /** @type {((inputs?: Irrigation_Pump_Confirm_Off_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Pump_Confirm_Off_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_pump_confirm_off_desc(inputs)
});